import React from 'react';

import BlockContent, {BlockContentProps} from '@sanity/block-content-to-react';
import {LabelledImage, EditorialContent} from 'src/components/shared';
import {ResponsiveContentWrapper} from 'src/components/shared/ResponsiveContentWrapper';
import {Typography} from 'src/components/shared/typography';
import {colors} from 'src/styleguide/colors';
import {fonts} from 'src/styleguide/typographyStyles';
import styled from 'styled-components/macro';

import {BodyCallOutText, Factoid, EmailBanner} from '../../components/editorial';
import {FloatedImage} from './FloatedImage';
import {EditorialGallery} from './Gallery';
import {PullQuoteImage} from './PullQuoteImage';
import {EditorialQuote} from './Quote';

export type RichContentType = typeof BlockContent;

const primaryTextAttributes = {
  mb: '2rem',
  fontSize: '1.125rem',
  lineHeight: '1.5rem',
  fontFamily: fonts.primary,
  color: colors.washingtonPostFontGray,
};

const EditorialWistiaVideo = styled('iframe')`
  width: 100%;
  height: 100%;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ListComponent: any = (props: any) =>
  props.type === 'number' ? <ol>{props.children}</ol> : <ul>{props.children}</ul>;

type BlockComponentStyles = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'normal' | 'blockquote';
export type SerializerProps = {
  children: JSX.Element;
  node: {
    style: BlockComponentStyles;
  };
};

const serializers: BlockContentProps['serializers'] = {
  marks: {
    link: ({mark, children}) => (
      <a href={mark.href} target="_blank" rel="noreferrer noopener">
        {children}
      </a>
    ),
  },
  list: ListComponent,
  types: {
    block: ({children, node}) => {
      switch (node.style) {
        case 'h1':
          return <h1>{children}</h1>;
        case 'h2':
          return <h2>{children}</h2>;
        case 'h3':
          return <h3>{children}</h3>;
        case 'h4':
          return <h4>{children}</h4>;
        case 'h5':
          return <h4>{children}</h4>;
        case 'h6':
          return <h4>{children}</h4>;
        default:
          return <p>{children}</p>;
      }
    },
  },
};

export const PodcastRichContent: RichContentType = props => (
  <EditorialContent serializers={serializers} blocks={props.blocks} className="text-gray prose" />
);
